import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";

import UsersTable from "../components/UsersTable";
import Loading from "../components/Loading";
import Error from "../components/Error";
import { useGetUsers } from "../hooks/user";

export default function Users() {
  const { data, isLoading, isError } = useGetUsers();

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return <Error />;
  }

  return (
    <div className="dashboard">
      <UsersTable users={data} />
      <Link to="/admin/create-user">
        <Button variant="contained" color="primary">
          Create User
        </Button>
      </Link>
    </div>
  );
}
